export default function datesAreSame(date1, date2) {
  if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
    return false;
  }

  return (
    `${date1.getFullYear()}${date1.getMonth()}${date1.getDate()}` ===
    `${date2.getFullYear()}${date2.getMonth()}${date2.getDate()}`
  );
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/datesAreSame.js
 **/